import MarketingSubscriptionConsent from './MarketingSubscriptionConsent';

export default {
  MarketingSubscriptionConsent,
};
